export type Environment = 'tst' | 'acc' | 'prd'

const API_BASE_URLS: Record<Environment, string> = {
  tst: 'https://tst.apim.suitsupply.com',
  acc: 'https://acc.apim.suitsupply.com',
  prd: 'https://apim.suitsupply.com',
}

const LANGUAGES_API_URLS: Record<Environment, string> = {
  tst: 'https://tst.apim.suitsupply.com/customer/customerpreference/api/v1/preferences/languages',
  acc: 'https://tst.apim.suitsupply.com/customer/customerpreference/api/v1/preferences/languages',
  prd: 'https://apim.suitsupply.com/customer/customerpreference/api/v1/preferences/languages',
}

export const API_ENDPOINTS = API_BASE_URLS

export function getApiBaseUrl(env: Environment): string {
  return API_BASE_URLS[env]
}

export function getLanguagesApiUrl(env: Environment): string {
  return LANGUAGES_API_URLS[env]
}

export const SEGMENT_WRITE_KEY = {
  tst: 'Zy9h9uXcEt0hpJd9Xlz3AKbISpOdqBmN',
  acc: 'vu6HG9YzL0vWMDsSiBz9jbF3TNXuU2US',
  prd: '4OhwIsrqFzQ0aeuYev8muGSWiimGtGIG',
}
